export default class OptionLift {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="lift_car a">
    <h2 class="title1">기종선택</h2>
    <div class="flex">
        <div class="left flex_column main-button-area">
            <div class="item flex" data-index="1" data-range="1~5">1인승</div>
            <div class="item flex" data-index="2" data-range="6~10">수직<span class="fz_10 fw_semobild   ml-05 mt-2">(밧데리)</span></div>
            <div class="item flex disabled" data-index="3" data-range="11~12">수직<span class="fz_10 fw_semobild   ml-05 mt-2">(엔진)</span></div>
            <div class="item flex disabled" data-index="4" data-range="13~14">직진<span class="fz_10 fw_semobild   ml-05 mt-2">(엔진)</span></div>
            <div class="item flex disabled" data-index="5" data-range="15~17">다 굴절</div>
            <div class="item flex disabled" data-index="6" data-range="18~20">Z형 직진</div>
        </div>
        <div class="right flex_column sub-button-area">
            <div class="flex" data-index="1">
                <div class="item flex" data-index="1" data-code="610" data-example="1">6m</div>
                <div class="item flex" data-index="2" data-code="612" data-example="1">8m</div>
                <div class="item flex" data-index="3" data-code="614" data-example="1">10m</div>
                <div class="item flex" data-index="4" data-code="616" data-example="1">12m</div>
                <div class="item flex" data-index="5" data-code="618" data-example="1">14m</div>
            </div>
            <div class="flex" data-index="2">
                <div class="item flex" data-index="6" data-code="620" data-example="1">6m</div>
                <div class="item flex" data-index="7" data-code="622" data-example="1">8m</div>
                <div class="item flex" data-index="8" data-code="624" data-example="1">10m</div>
                <div class="item flex" data-index="9" data-code="626" data-example="1">12m</div>
                <div class="item flex" data-index="10" data-code="628" data-example="1">14m</div>
            </div>
            <div class="flex" data-index="3">
                <div class="item flex disabled" data-index="11" data-code="630">14m</div>
                <div class="item flex disabled" data-index="12" data-code="632">17m</div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="4">
                <div class="item flex disabled" data-index="13" data-code="634">14m</div>
                <div class="item flex disabled" data-index="14" data-code="636">20m</div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="5">
                <div class="item flex disabled" data-index="15" data-code="640">12m</div>
                <div class="item flex disabled" data-index="16" data-code="642">16m</div>
                <div class="item flex disabled" data-index="17" data-code="644">20m</div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="6">
                <div class="item flex disabled" data-index="18" data-code="650">11m</div>
                <div class="item flex disabled" data-index="19" data-code="652">14m</div>
                <div class="item flex disabled" data-index="20" data-code="654">26m</div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
        </div>
    </div>
    <h2 class="title1">운반비</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <div class="item flex" data-value="왕복" data-code="600">
                왕복운반비
            </div>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="blank"></div>
    <div class="button flex apply-data">
        <div class="button_yellow flex">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;
        console.log('window.option.lift.init');
        this.parent.load();// 변수 초기화
        this.parent.drawJungo();// 전고 그리기 ( 최초한번만 )
        this.parent.draw();// 톤수,미터를 그린다.
        this.parent.initMainButtonHandler();// 메인 버튼을 클릭했을때
        this.parent.initSubButtonHandler();// 서브 버튼을 클릭했을때
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler();// 완료버튼 클릭시
    }
    /**
     * car_range 값을 업데이트한다.
     */
    updateRange = function (){
        const self = this;
        const arr = [];
        // 서브버튼 순회
        $('#'+this.parent.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if( self.parent.subIdxList.includes(idx) ) arr.push( $(this).attr('data-code'));
        });

        // const arr = this.parent.subCodeList;
        const min = Math.min(...arr);
        const max = Math.max(...arr);
        let range = '';
        range = `${min}~${max}`;
        const data = this.parent.data;
        data['car_range']=range;
    }
}
